import {
  ProductBase,
  ProductType,
  CreateProductParams,
} from './base/ProductBase';
import { Product as TProduct } from '~redux/brand/types';

export class Product extends ProductBase {
  private constructor(params: ProductType) {
    super(params);
  }

  static create({ ...product }: CreateProductParams) {
    return new Product(product as ProductType);
  }

  create(params: CreateProductParams) {
    return Product.create(params);
  }

  createById(productId: string) {
    return Product.createById(productId);
  }

  createWithImageUrl(product: TProduct) {
    return Product.createWithImageUrl(product);
  }

  getById(productId: string) {
    return Product.getById(productId);
  }

  register(
    ...params: Parameters<typeof ProductBase.register>
  ): ReturnType<typeof ProductBase.register> {
    return Product.register(...params);
  }

  get isSaleProduct() {
    return !!this.product_sale_wholesale_rate;
  }

  get productWholesaleRate() {
    return this.product_wholesale_rate + (this.discountRate ?? 0);
  }

  get productSaleWholesaleRate() {
    return this.product_sale_wholesale_rate;
  }
}
